import type { AppThemeConfig } from "./theme.types";
import type { getDarkModeColor } from "./dark-mode";

// Also serialized into the initial HTML: keep runtime dependencies in arguments.
export function applyThemeConfig(
  config: AppThemeConfig,
  darkMode: boolean,
  darkColor: typeof getDarkModeColor
): void {
  const root = document.documentElement;
  root.dataset.colorScheme = darkMode ? "dark" : "light";
  root.style.colorScheme = darkMode ? "dark" : "light";
  const color = (value: string, background = false) =>
    darkMode ? darkColor(value, background) : value;
  root.style.setProperty("--var-color-brand-dark", color(config.colorBrandDark));
  root.style.setProperty(
    "--var-color-background-gradient-from",
    color(config.colorBackgroundGradientFrom, true)
  );
  root.style.setProperty(
    "--var-color-background-gradient-to",
    color(config.colorBackgroundGradientTo, true)
  );
  if (config.colorSidebar) {
    root.style.setProperty("--var-color-sidebar", color(config.colorSidebar, true));
  } else {
    root.style.removeProperty("--var-color-sidebar");
  }
  root.style.setProperty("--color-dark", darkMode ? "#fff" : "hsl(220 10% 12%)");
  root.style.setProperty("--color-light", darkMode ? "hsl(220 10% 12%)" : "#fff");
  root.style.setProperty(
    "--color-dark-5",
    darkMode ? "rgb(255 255 255 / 0.05)" : "hsl(220 10% 12% / 0.05)"
  );
  root.style.setProperty(
    "--color-dark-10",
    darkMode ? "rgb(255 255 255 / 0.1)" : "hsl(220 10% 12% / 0.1)"
  );
  root.style.setProperty("--color-brand-light", darkMode ? "hsl(220 10% 18%)" : "hsl(210 12% 97%)");
}
